/* Hell/Dunkel-Umschalter.
   Der Modus wird bereits im <head> gesetzt (Inline-Skript), damit die Seite
   nicht kurz in der falschen Farbe aufblitzt. Hier hängt nur noch der Klick
   auf den Knopf und die Beschriftung dran. */
(function () {
  'use strict';

  var KEY = 'ibc-theme';

  function label(mode) {
    return mode === 'light' ? 'Zu dunklem Modus wechseln' : 'Zu hellem Modus wechseln';
  }

  function apply(mode) {
    document.documentElement.setAttribute('data-theme', mode);
    document.querySelectorAll('[data-action="toggle-theme"]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', mode === 'light' ? 'true' : 'false');
      btn.setAttribute('aria-label', label(mode));
      btn.setAttribute('title', label(mode));
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-action="toggle-theme"]')) return;

    var next = document.documentElement.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
    try { localStorage.setItem(KEY, next); } catch (e) {}
    apply(next);
  });

  // Wechsel in einem anderen Tab übernehmen
  window.addEventListener('storage', function (event) {
    if (event.key === KEY && event.newValue) apply(event.newValue);
  });

  apply(document.documentElement.getAttribute('data-theme') || 'dark');
})();
